/*
 * @Description: 关键事件
 * @Author: yy
 * @Date: 2019-05-31 14:47:31
 * @LastEditors: yy
 * @LastEditTime: 2019-09-02 16:01:04
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Article.css';
import cx from 'classnames';
import moment from 'moment'
import Link from '../Link';
import kolV from './kolV.png'
import ArticleAddBrand from  '../ArticleAddBrand'

import PageInput from './pageInput'
import { updateBrandEmotion } from '../../controller';


const plBtn=[
  '所有平台',
  '微信',
  '微博',
  '知乎',
  '今日头条'
]


const plRange=[
  '单日',
  '七日'
]

const listTxt=[
  {
    txt:'10条/页',
    num:10
  },{
    txt:'20条/页',
    num:20
  },{
    txt:'30条/页',
    num:30
  }
]



class Article extends React.Component {
  constructor(props){
    super(props)
    this.state={
      commonArticle:[],
      kolArticle:[],
      loadding:false,
      m:moment,
      delBtn:false,
      plBtn:0,
      plRange:0,
      lookMore:false,
      articleLength:0,
      nowPage:1,
      jumpInputValue:1,
      listNum:10,
    }
    this.brandRender=this.brandRender.bind(this)
    this.fromRender=this.fromRender.bind(this)
    this.getArtJson=this.getArtJson.bind(this)

    this.delArt=this.delArt.bind(this)
    this.delBrand=this.delBrand.bind(this)
    this.changeBrandEmotion=this.changeBrandEmotion.bind(this)
    this.jumpInputOnchange=this.jumpInputOnchange.bind(this)
    this.pageBtnClick=this.pageBtnClick.bind(this)
  }

  changeBrandEmotion=(i,artItem,index)=>{

    let like
    if(index==0){
      like='推荐'
    }else if(index==1){
      like='好感'
    }else if(index==2){
      like='中立'
    }else if(index==3){
      like='差评'
    }else if(index==4){
      like='反感'
    }

    if( confirm(`确定将 ${i.brandName} 品牌的好感度设置为 ${like}？`) ){
      console.log(artItem.url,artItem.from)
      let m=artItem.date.substring(0,2)
      let d=artItem.date.substring(3,5)
      let artDate
      if(m>10){
        artDate =moment(`${m}-${d}`,'MM-DD').format('2017-MM-DD')
      }else{
        artDate =moment(`${m}-${d}`,'MM-DD').format('2018-MM-DD')
      }

      updateBrandEmotion({
        url: artItem.url,
        platform: artItem.from,
        statisDate: artItem.statisDate,
        brand_id: i.brandId,
        emotion: index+1
      })
      .then(data => {
        // console.log(data,'····更改品牌好感···')
        // this.setState({
           
        // })
        // console.log('ss',this.state.commonArticle)
      })
      .catch(e => console.log("Oops, error", e))
      alert('正在重置品牌好感度请稍等')
      
      // this.getArtJson(this.props,this.state.plBtn,this.state.plRange)
      this.getArtJson({})
      
    }
  }

  delBrand=(i,artItem)=>{
    // console.log(i.brandId)
    // console.log(artItem)
    if( confirm(`确定删除  ${i.brandName} 品牌？ `) ){
      console.log(artItem.url,artItem.from)
      let m=artItem.date.substring(0,2)
      let d=artItem.date.substring(3,5)
      // let artDate =moment(`${m}-${d}`,'MM-DD').format('YYYY-MM-DD')

      let artDate
      if(m>10){
        artDate =moment(`${m}-${d}`,'MM-DD').format('2017-MM-DD')
      }else{
        artDate =moment(`${m}-${d}`,'MM-DD').format('2018-MM-DD')
      }
      console.log(artDate,m,d,)

      let url=`/digitalAssets/article/delete_brand?url=${encodeURIComponent(artItem.url)}&platform=${artItem.from}&statisDate=${artItem.statisDate}&brand_id=${i.brandId}`
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit).then(response => response.json())
      .then(data => {
        console.log(data,'····删除品牌数据···')
        this.setState({
           
        })
        // console.log('ss',this.state.commonArticle)
      })
      .catch(e => console.log("Oops, error", e))
      alert('正在删除品牌请稍等')
      
      // this.getArtJson(this.props)
      // this.getArtJson(this.props,this.state.plBtn,this.state.plRange)
      this.getArtJson({})
    }
  }



  delArt=(i)=>{
    // alert(`删除！${i.txt}`)


    if( confirm(`确定删除文章？${i.txt}`) ){
      // console.log(i.url)
      let m=i.date.substring(0,2)
      let d=i.date.substring(3,5)
      // let artDate =moment(`${m}-${d}`,'MM-DD').format('YYYY-MM-DD')
      let artDate
      if(m>10){
        artDate =moment(`${m}-${d}`,'MM-DD').format('2017-MM-DD')
      }else{
        artDate =moment(`${m}-${d}`,'MM-DD').format('2018-MM-DD')
      }
      // console.log(artDate,m,d,)
      
      let url=`/digitalAssets/delete_article?url=${encodeURIComponent(i.url)}&platform=${i.from}&statisDate=${i.statisDate}`
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
      fetch(url,myInit).then(response => response.json())
      .then(data => {
        console.log(data,'······修改数据···')
        this.setState({
           
        })
        // console.log('ss',this.state.commonArticle)
      })
      .catch(e => console.log("Oops, error", e))

      alert('正在删除文章请稍等')

      // this.getArtJson(this.props,this.state.plBtn,this.state.plRange)
      this.getArtJson({})
      
    
    }
  

  }
 


  getArtJson=({props=this.props,pl=this.state.plBtn,range=this.state.plRange,num=this.state.listNum,pageNum=this.state.nowPage})=>{
    // console.log(items,'文章数据的items`````````````````````')
    // console.log(props,'这是props')
    const {m,plBtn}=this.state
    let {time,items,region,industry,platform,isLevelIndustry}=props
    this.setState({
      commonArticle:[],
      kolArticle:[]
    })

    // console.log(`${time.substring(5,7)}`>10)
    // const start=`${time.substring(5,7)}`>10?m(`${time.substring(0,10)}`,'YYYY-MM-DD').format('2017-MM-DD'):m(`${time.substring(0,10)}`,'YYYY-MM-DD').format('2018-MM-DD')
    // const end=`${time.substring(16,18)}`>10?m(`${time.substring(11,21)}`,'YYYY-MM-DD').format('2017-MM-DD'):m(`${time.substring(11,21)}`,'YYYY-MM-DD').format('2018-MM-DD')
    
    const start=`${time.substring(0,10)}`
    const end=`${time.substring(11,21)}`

    // console.log(start,end,`${time.substring(5,7)}`,time.substring(11,21))
    let url
    if(region){
      url=`/digitalAssets/article?region=${encodeURIComponent(region)}&startDate=${start}&statisDate=${end}&pageNum=${pageNum}&num=${num}`

    }else if(industry&&!isLevelIndustry){
      url=`/digitalAssets/article?industry=${encodeURIComponent(industry)}&startDate=${start}&statisDate=${end}&pageNum=${pageNum}&num=${num}`
      
    }else if(platform){
      url=`/digitalAssets/article?platform=${encodeURIComponent(platform)}&startDate=${start}&statisDate=${end}&pageNum=${pageNum}&num=${num}`
      
    }else if(items){
      let aa=''
      switch(pl){
        case 0:
        aa=''
        break;
        case 1:
        aa=`&platform=${encodeURIComponent('微信')}`
        break;
        case 2:
        aa=`&platform=${encodeURIComponent('微博')}`
        break;
        case 3:
        aa=`&platform=${encodeURIComponent('知乎')}`
        break;
        case 4:
        aa=`&platform=${encodeURIComponent('今日头条')}`
        break;
      }
      const hasIndustry=isLevelIndustry&&industry
            ?`&industry=${encodeURIComponent(industry)}`
            :''
      
      
      if(range==1){
        // 七天
        url = `/digitalAssets/article?brandName=${encodeURIComponent(items[0].name)}&startDate=${start}&statisDate=${end}${aa}&pageNum=${pageNum}&num=${num}${hasIndustry}`;
        
      }else{
        // 单日
        url = `/digitalAssets/article?brandName=${encodeURIComponent(items[0].name)}&startDate=${end}&statisDate=${end}${aa}&pageNum=${pageNum}&num=${num}${hasIndustry}`;
        
      }


      //  url = `/digitalAssets/article?brandName=${encodeURIComponent(items[0].name)}&&startDate=${start}&&statisDate=${end}&${aa}`;
      //  url = `/digitalAssets/article?brandName=${encodeURIComponent(items[0].name)}&&startDate=${end}&&statisDate=${end}&${aa}`;
      
    }else{
      
        url = `/digitalAssets/article?startDate=${start}&statisDate=${end}`;
        
    }

    // url=`/digitalAssets/article?brandName=华为&startDate=2018-05-02&statisDate=2018-05-20&pageNum=${pageNum}&num=${num}`
    // console.log(url)

    const myInit = {
      method: 'GET',
      credentials: 'include', 
      mode: 'cors',
      cache: 'no-cache' 
    };
    fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
        // console.log(data,'文章文章文章数据··················')
        

        //文章关联品牌第一位
        const docSort=({topDocList,kolDocList})=>{
          
            topDocList&&topDocList.map((j)=>{
              j.brandList.map((i,index)=>{

                if(i.brandName==items[0].name){
                  j.brandList.unshift(i)    
                  j.brandList.splice(index+1,1)
                }
              })
            
            })
            kolDocList&&kolDocList.map((j)=>{
              j.brandList.map((i,index)=>{

                if(i.brandName==items[0].name){
                  j.brandList.unshift(i)
                  j.brandList.splice(index+1,1)
                }
              })
            
            })

            return data
        }
      
        if(items)  docSort(data)

      

        this.setState({
            commonArticle:data.topDocList,
            kolArticle:data.kolDocList,
            loading:false,
            articleLength:data.articleLength||0,
            // nowPage:1,
        })
        if(data.err_code=='need_login'){
          alert('需要重新登录才能查看文章！')
        }
        // console.log('ss',this.state.commonArticle)
      })
      .catch(e => console.log("Oops, error", e))
  }

  componentDidMount() {
    this.getArtJson({})
  }


  componentWillReceiveProps(nextProps) {

   

    if(nextProps.time!=this.props.time){

      // this.getArtJson(nextProps,this.state.plBtn,this.plRange)
      this.getArtJson({props:nextProps})
      
      // this.getArtJson(nextProps,this.state.plBtn,this.plRange)
      
    }else if(nextProps.industry!=this.props.industry){
      this.getArtJson({props:nextProps})
      
      // this.getArtJson(nextProps,this.state.plBtn,this.plRange)
      
    }else if(nextProps.region!=this.props.region){
      this.getArtJson({props:nextProps})
      
      // this.getArtJson(nextProps,this.state.plBtn,this.plRange)
      
    }else if(nextProps.platform!=this.props.platform){
      this.getArtJson({props:nextProps})
      
      // this.getArtJson(nextProps,this.state.plBtn,this.plRange)
      
    }else if(nextProps.items&&nextProps.items[0].name!=this.props.items[0].name){
      this.getArtJson({props:nextProps})
      
      // this.getArtJson(nextProps,this.state.plBtn,this.plRange)
      
    }else{
      return false
    }
  }


   

  fromRender=(item)=>{
    let from=item.from

      if(from=='wb'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>微博</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon3}></i>
                <em className={s.postsNum}>转发：{item.repostsCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon5}></i>
                <em className={s.postsNum}>评论：{item.commentsCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon4}></i>
                <em className={s.postsNum}>点赞：{item.attitudesCount}</em>
              </span>
            </div>
          </div>
        )
      }else if(from=='wx'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>微信</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon2}></i>
                <em className={s.postsNum}>阅读：{item.readCount>100000?'10W+':item.readCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon7}></i>
                <em className={s.postsNum}>在看：{item.attitudesCount}</em>
              </span>
            </div>
          </div>
        )
      }else if(from=='zh'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>知乎</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon6}></i>
                <em className={s.postsNum}>赞同：{item.attitudesCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon5}></i>
                <em className={s.postsNum}>评论：{item.commentsCount}</em>
              </span>
            </div>
          </div>
        )
      }else if(from=='tt'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>今日头条</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon2}></i>
                <em className={s.postsNum}>阅读：{item.readCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon5}></i>
                <em className={s.postsNum}>评论：{item.commentsCount}</em>
              </span>
            </div>
          </div>
        )
      }else if(from=='wk'){
        return (
          <div className={s.postsInfo}>
            <div className={s.left}>
              <span className={s.postsAdd}>悟空问答</span>
              <span className={s.postsDate}>{item.date}</span>
            </div>
            <div className={s.right}>
              <span className={s.postsFlow}>
                <i className={s.postsIcon2}></i>
                <em className={s.postsNum}>赞同：{item.attitudesCount}</em>
              </span>
              <span className={s.postsFlow}>
                <i className={s.postsIcon5}></i>
                <em className={s.postsNum}>评论：{item.commentsCount}</em>
              </span>
            </div>
          </div>
        )
      }
  }
  brandRender=(item)=>{
    
    
    // if(item.brandList.length>3){
    //   item.brandList.length=3          
    // }
    let artItem=item


    let ss=(emotion)=>{
      if(emotion==1){
        return s.brandLike1
      }else if(emotion==2){
        return s.brandLike2
      }else if(emotion==3){
        return s.brandLike3
      }else if(emotion==4){
        return s.brandLike4
      }else if(emotion==5){
        return s.brandLike5
      }
    }


    let clickEmotion=[
      'brandLike1',
      'brandLike2',
      'brandLike3',
      'brandLike4',
      'brandLike5',
    ]
    return (
      
      <ul className={s.postsBrandList}>
        {item.brandList.map((item,i)=>
         
              <li className={s.postsBrand} key={i}>
                <span className={s.brandP}>
                  <span className={s.delBrandClass}  onClick={()=>this.delBrand(item,artItem)}>删除</span>
                    {item.brandName}
                  <Link className={s.herfBrandClass} to={`/dashboard?brandName=${item.brandName}`} >跳转</Link>
                </span>
                <i className={s.brandImg} >
                    <img src={`/digitalAssets/resources/img/LOGO/${item.brandId}.png`}/>
                    <ul className={s.emotionUl}>
                      {clickEmotion.map((emotionImg,i)=>
                        <li key={i} className={s.emotionList} 
                         onClick={()=>this.changeBrandEmotion(item,artItem,i)} >
                            <i className={s[emotionImg]}></i>
                        </li>
                      )}
                    </ul>
                </i>
                <i className={ss(item.emotion)}></i>
                
              </li>        
            )
        }
        {/* {item.brandList.length<3&& */}
          <ArticleAddBrand i={item}   refresh={()=>{this.getArtJson(this.props)}}/>
        {/* }  */}
      </ul>  
    )
    
    
  }


  jumpInputOnchange=(e)=>{
    const {value}=e.target
    


    if(e.keyCode=='13'){
      this.getArtJson({pageNum:Number(value)})
    }

  }


  pageBtnClick=(callback,{action})=>{
    if(action=='add'){
      this.setState(prevState=>({nowPage:Number(prevState.nowPage)+1}))
      callback({pageNum:Number(this.state.nowPage)+1})
    }else{
      this.setState(prevState=>({nowPage:Number(prevState.nowPage)-1}))
      callback({pageNum:Number(this.state.nowPage)-1})
      
    }

    

  }




 

  render() {
    

    
    

    const {kolArticle,commonArticle,articleLength,nowPage,listNum}=this.state
    // console.log(kolArticle,commonArticle)
    const {time}=this.props
    const today=time.substring(11,21)
    // console.log(time,today)
    // const RenderPageNumBtn=()=>{
      
          // 期望   简洁翻页   《 [1]/5 》 √    [10条/页]  √
      // const {articleLength,nowPage,jumpInputValue,listNum}=this.state
      const total=Math.ceil(articleLength/listNum)
      // console.log(articleLength,Math.ceil(articleLength/6),total)
      
  
  
     
    // }





    
    return (
      <div className={s.root}>
        {this.props.items?
          <ul className={s.plBtnUl}>
          {plBtn.map((btn,i)=>(
            <li key={i} className={i==this.state.plBtn?s.plBtnAc:null} 
            onClick={()=>{
              this.setState({plBtn:i,nowPage:1})
              {/* this.getArtJson(this.props,i,this.state.plRange) */}
              this.getArtJson({pl:i,pageNum:1})
            }}>
              {btn}
            </li>
          ))}
         </ul>
        :null}
        {this.props.items?
          <ul className={s.plRangeUl}>
          {plRange.map((btn,i)=>(
            <li key={i} className={i==this.state.plRange?s.plBtnAc:null} 
            onClick={()=>{
              this.setState({plRange:i,nowPage:1})
              {/* this.getArtJson(this.props,this.state.plBtn,i) */}
              this.getArtJson({range:i,pageNum:1})
              
            }}>
              {btn}
            </li>
          ))}
         </ul>
        :null}
        

        <div className={cx(s.conFoot, s.clearfix)} id="floatShow">
          {/* <!--文章排行--> */}
          <div className={cx(s.fl, s.footRank)}>
            <span className={s.articleTit}>关键事件</span>
            <span className={s.int}>Hot Posts</span>
            {commonArticle&&commonArticle.length!=0?
            
            <ul>
              {commonArticle.map((item,i)=>(
                <li key={i} className={s.postsItem}>
                  <span className={s.artDelBtn}  onClick={()=>this.delArt(item)}>删除</span>
                  <div className={s.postsIndex}>{Number((nowPage-1)*listNum)+i+1}</div>
                  <div className={s.postsCon}>
                    <div className={s.postsHead}>
                      <a target='_blank' href={item.url} className={s.postsTxt}>{item.txt}</a>
                      {this.fromRender(item)}                    
                    </div>
                    {item.brandList[0].db&&<span style={{height:'20px'}}>db值：{`${parseFloat(item.brandList[0].db).toLocaleString()}`}</span>}
                    
                    <div className={s.postsFoot}>
                      <div className={s.postsInt}>关联品牌：</div>
                      {this.brandRender(item)}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            :<div>{today} 没有关键事件文章</div>}
            
          </div>
          {/* <!--KOL排行--> */}
          <div className={s.footRank}>
            <span className={s.articleTit}>KOL关联</span>
            <span className={s.int}>Involved KOLs</span>
            {kolArticle&&kolArticle.length!=0?
            <ul>
              {kolArticle.map((item,i)=>(
                <li key={i} className={s.postsItem}>
                  <span className={s.artDelBtn}  onClick={()=>this.delArt(item)}>删除</span>
                  <div className={s.postsIndex}>{Number((nowPage-1)*listNum)+i+1}</div>
                  <div className={s.postsCon}>
                    <div className={s.postsHead}>
                      <div className={s.userItem}>
                        <i className={s.userImg}><img src={item.kolImg}/><img src={kolV} className={s.kolV}/></i>
                        <a target='_blank' href={item.from=='wx'?'javascript:;':item.kolUrl} className={s.userName}>{item.kolName}</a>
                        <a target='_blank' href={item.url} className={s.postsTxt2}>{item.txt}</a>
                      </div>
                      {this.fromRender(item)}                    
                    </div>
                    {item.brandList[0].db&&<span style={{height:'20px'}}>db值：{`${parseFloat(item.brandList[0].db).toLocaleString()}`}</span>}
                    <div className={s.postsFoot}>
                      <div className={s.postsInt}>关联品牌：</div>
                        {this.brandRender(item)}                    
                    </div>
                  </div>
                </li>
              ))}
              
              
            </ul>
            :<div>{today} 没有KOL关联文章</div>}
            
          </div>
        </div>
        <div className={s.pagePosi}>
         
          {/* {this.renderPageNumBtn()} */}
          {/* <RenderPageNumBtn /> */}
          <div className={s.pageConBox}>
            <span className={s.pageActionBox}  onClick={()=>nowPage==1?null:this.pageBtnClick(this.getArtJson,{action:'reduce'})}>{'<'}</span>
            {/* <input value={nowPage} onChange={(e)=>this.setState({nowPage:e.target.value})}  onKeyDown={this.jumpInputOnchange}/> */}
            <PageInput nowPage={nowPage} getArtJson={this.getArtJson} changePageNum={(num)=>this.setState({nowPage:num})} />
            <span className={s.pageTotal}>/{total}</span>
            <span className={s.pageActionBox}  onClick={()=>nowPage==total?null:this.pageBtnClick(this.getArtJson,{action:'add'})}>></span>
      
            <select className={s.selectCls} value={listNum} onChange={(e)=>{
              this.setState({listNum:e.target.value})
              this.getArtJson({num:e.target.value})
            }}>
              {listTxt.map(i=>
                <option key={i.num} value={i.num}>{i.txt}</option>
              )}
            </select>
      
          </div>
        </div>
        
      </div>
    )

  }
}

export default withStyles(s)(Article);



// WEBPACK FOOTER //
// src/components/Article/Article.js